import SimpleBar from "simplebar-react";
import classNames from "classnames";

import MediaPostModalFooter from "../MediaPostModalFooter";
import ViewPostModalLocked from "../ViewPostModalLocked";
import PostModalBackdrop from "../PostModalBackdrop";
import ViewPostModalReported from "../ViewPostModalReported";
import ViewFiles from "../ViewFiles";
import FilesCounters from "../FilesCounters";
import { countFiles } from "@helpers/posts";
import { useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";

import { XL } from "@const/breakpoints";

import styles from "./index.module.scss";

const ViewPostModalContent = (
  {
    content,
    title,
    authorId,
    description,
    isLocked,
    username,
    accessType,
    isBlurredByReports,
    id,
    uniqueKey,
    priceType,
    subscriptions,
    accessToken,
    withArrows,
  },
  ref,
) => {
  const isDesktop = useMediaQuery({
    query: `(min-width: ${XL})`,
  });

  const { videosCount, imagesCount, audiosCount } = useSelector(
    ({ postsReducer, scheduledPostsReducer }) =>
      postsReducer?.postById?.[id] || {},
  );

  const contentFiles = content?.map(({ file }) => file) || [];

  const fileCounts = countFiles(contentFiles);

  if (isLocked) {
    return (
      <ViewPostModalLocked
        id={id}
        uniqueKey={uniqueKey}
        authorId={authorId}
        title={title}
        username={username}
        content={content}
        accessType={accessType}
        subscribe
        modalView
        priceType={priceType}
        subscriptions={subscriptions}
        canBePayed
        accessToken={accessToken}
        withArrows={withArrows}
        videosCount={videosCount}
        imagesCount={imagesCount}
        audiosCount={audiosCount}
      />
    );
  }

  return (
    <>
      <SimpleBar className={classNames("post-detail-scroll", styles.container)}>
        <div className="w-100" style={{ maxWidth: "calc(1200px - 380px)" }}>
          <FilesCounters
            {...fileCounts}
            containerStyles="position-absolute post-chip"
          />
          {isBlurredByReports ? (
            <ViewPostModalReported content={content} postId={id} />
          ) : (
            <ViewFiles content={content} showOriginalFiles ref={ref} />
          )}
        </div>
        {isDesktop && (
          <MediaPostModalFooter title={title} description={description} />
        )}
      </SimpleBar>
      {isDesktop && <PostModalBackdrop />}
    </>
  );
};

export default ViewPostModalContent;
